import { isAfter, isBefore, subDays } from "date-fns";
import { IWalletLoan } from "./types.ts";
import { errorAlert } from "./alerts.tsx";

export const vigencia = (loan: any) => {
  const obj: { vigencia: number; date: string | Date } = {
    vigencia: 0,
    date: "",
  };
  const date_today = new Date();

  loan.payment_plans.forEach((payment_plan: any) => {
    const format_aux = new Date(payment_plan.c202_fecha_cuota);

    if (isAfter(format_aux, date_today)) {
      obj.vigencia = 1;
      obj.date = format_aux;
    }
  });

  return obj;
};

export const getNextDueToPay = (loan: IWalletLoan) => {
  const nextDuesFromToday = loan.payment_plans.filter(
    (payment_plan) =>
      isAfter(new Date(payment_plan.c202_fecha_cuota), new Date()) &&
      (payment_plan.c202_ind_estado === "0" ||
        payment_plan.c202_ind_estado === "2")
  );

  if (nextDuesFromToday.length !== 0) {
    return nextDuesFromToday[0];
  } else {
    return loan.payment_plans[loan.payment_plans.length - 1];
  }
};

const validateTypePenalties = (penalties: any) => {
  return typeof penalties == "string" ? JSON.parse(penalties) : penalties;
};

export const spMapping = (loan: IWalletLoan) => {
  try {
    const arr_test: {
      c2_total: number;
      c2_c230_valor_pendiente: number;
      c2_c211_cobranza: number;
      c2_c211_sanciones: number;
      c2_c210_valor_complementos: number;
      c2_c202_valor: number;
    }[] = [];

    loan.payment_plans.forEach((payment_plan) => {
      if (
        isBefore(
          new Date(payment_plan.c202_fecha_cuota),
          subDays(new Date(), 1)
        )
      ) {
        const obj = {
          c2_total: 0,
          c2_c230_valor_pendiente: 0,
          c2_c211_cobranza: 0,
          c2_c211_sanciones: 0,
          c2_c210_valor_complementos: 0,
          c2_c202_valor: 0,
        };
        payment_plan.plan_payment_penalties = validateTypePenalties(
          payment_plan.plan_payment_penalties
        );

        if (payment_plan.c202_ind_estado + "" === "0") {
          const penaltie: any = (
            payment_plan as any
          ).plan_payment_penalties.find(
            ({ c211_ind_estado }: any) => c211_ind_estado + "" === "0"
          );

          obj.c2_c202_valor = parseInt(payment_plan.c202_vlr_cuota);
          obj.c2_c210_valor_complementos =
            payment_plan.additional_payment_plan.reduce(
              (acum, { c210_vlr_cuota }) => acum + parseInt(c210_vlr_cuota),
              0
            );
          obj.c2_c211_sanciones =
            penaltie &&
            penaltie !== null &&
            penaltie.c211_valor_sancion !== ".0000"
              ? parseInt(penaltie.c211_valor_sancion)
              : 0;
          obj.c2_c211_cobranza =
            penaltie &&
            penaltie !== null &&
            penaltie.c211_gastos_cobranza !== ".0000" &&
            penaltie.c211_gastos_cobranza != null
              ? parseInt(penaltie.c211_gastos_cobranza)
              : 0;
          obj.c2_total =
            obj.c2_c211_sanciones +
            obj.c2_c211_cobranza +
            obj.c2_c210_valor_complementos +
            obj.c2_c202_valor +
            obj.c2_c230_valor_pendiente;

          arr_test.push(obj);
        } else if (payment_plan.c202_ind_estado + "" === "2") {
          const penaltie: any = (
            payment_plan as any
          ).plan_payment_penalties.find(
            ({ c211_ind_estado }: any) => c211_ind_estado + "" === "0"
          );

          obj.c2_c230_valor_pendiente = parseInt(
            loan.banking_transaction.find(
              ({ c230_ind_estado }) => c230_ind_estado + "" === "2"
            )!.c230_valor_pendiente
          );

          obj.c2_c211_sanciones =
            penaltie &&
            penaltie !== null &&
            penaltie.c211_valor_sancion !== ".0000"
              ? parseInt(penaltie.c211_valor_sancion)
              : 0;
          obj.c2_c211_cobranza =
            penaltie &&
            penaltie !== null &&
            penaltie.c211_gastos_cobranza !== ".0000" &&
            penaltie.c211_gastos_cobranza != null
              ? parseInt(penaltie.c211_gastos_cobranza)
              : 0;
          obj.c2_total =
            obj.c2_c211_sanciones +
            obj.c2_c211_cobranza +
            obj.c2_c210_valor_complementos +
            obj.c2_c202_valor +
            obj.c2_c230_valor_pendiente;

          arr_test.push(obj);
        }
      }
    });

    return arr_test;
  } catch (error: any) {
    console.log("Error en el spMapping", error, loan);
    errorAlert(
      "Ha ocurrido un error",
      "Error en el 'spMapping'",
      error.name + " - " + error.message
    );

    return [];
  }
};
